import React, { Component } from 'react'
import { withRouter, Route, Switch } from "react-router-dom";
import { AppBar, Tabs, Tab } from '@material-ui/core';
import DatosGenerales from './datosgenerales/DatosGenerales';
import Cliente from './Cliente';
import Remitentes from './remitentes/Remitentes';
import Destinatarios from './destinatarios/Destinatarios';
import Ventas from './ventas/Ventas';
import Administrativos from './administrativos/Administrativos';
import Precios from './precios/Precios';
import Estadisticos from './estadisticos/Estadistico';
import Representante from './repLegal/RepLegal';
import Cfdi from './cfdi/Cfdi';
import Pagos from './pagos/Pagos';
import Convenios from './convenios/Convenios';
import Grupos from './grupoClientes/grupoClientes';
import FoliosUso from './folios-uso/FoliosUso';
import PagosSucursales from './pagoTransportista/PagosSucursales';
import { AuthContext } from '../../../context/authContext';
import Factoraje from './factoraje/Factoraje';
import ApiConfig from './api/apiConfig';
import EdiConfig from './edi/EdiConfig';
import ACCESS from '../../../ACCESS';

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <Typography
//       component="div"
//       role="tabpanel"
//       hidden={value !== index}
//       id={`scrollable-auto-tabpanel-${index}`}
//       aria-labelledby={`scrollable-auto-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box p={3}>{children}</Box>}
//     </Typography>
//   );
// }

const tab = (label, route, path, Component, access = []) => {
  return {
    label, route, path, Component, access
  }
}
class ClienteInfo extends Component {
  state = {
    value: 'Generales',
    recursos: []
  }


  // _baseUrl = `/Catalogo/Cliente/${this.props.match.params.id}`
  tabs = [
    tab('Datos generales', `Generales`, `/Catalogo/Cliente/:id/Generales`, DatosGenerales, [ACCESS.CATALOGO_CLIENTES.VER_CATALOGO, ACCESS.CATALOGO_CLIENTES.VER_SOLO_CONTADO, ACCESS.CATALOGO_CLIENTES.VER_SOLO_CREDITO]),
    tab('Grupo', `Grupos`, `/Catalogo/Cliente/:id/Grupos/:tabId?`, Grupos, [ACCESS.CATALOGO_CLIENTES_GRUPO.VER_CATALOGO]),
    tab('Remitente', `Remitentes`, `/Catalogo/Cliente/:id/Remitentes/:tabId?`, Remitentes, [ACCESS.CATALOGO_CLIENTES_REMITENTE.VER_CATALOGO]),
    tab('Destinatario', `Destinatarios`, `/Catalogo/Cliente/:id/Destinatarios/:tabId?`, Destinatarios, [ACCESS.CATALOGO_CLIENTES_DESTINATARIO.VER_CATALOGO]),
    tab('Venta', `Ventas`, `/Catalogo/Cliente/:id/Ventas/:tabId?`, Ventas, [ACCESS.CATALOGO_CLIENTES_VENTA.EDITAR_CATALOGO]),
    tab('Administrativo', `Administrativos`, `/Catalogo/Cliente/:id/Administrativos/:tabId?`, Administrativos, [ACCESS.CATALOGO_CLIENTES_ADMINISTRATIVO.VER_CATALOGO]),
    tab('Estadistico', `Estadisticos`, `/Catalogo/Cliente/:id/Estadisticos/:tabId?`, Estadisticos, [ACCESS.CATALOGO_CLIENTES_ESTADISTICO.VER_CATALOGO]),
    tab('Rep Legal', `Representante`, `/Catalogo/Cliente/:id/Representante/:tabId?`, Representante, [ACCESS.CATALOGO_CLIENTES_REP_LEGAL.VER_CATALOGO]),
    tab('CFDI', `Cfdi`, `/Catalogo/Cliente/:id/Cfdi/:tabId?`, Cfdi, [ACCESS.CATALOGO_CLIENTES_CFDI.VER_CATALOGO]),
    tab('Convenio', `Convenios`, `/Catalogo/Cliente/:id/Convenios/:tabId?`, Convenios, [ACCESS.CATALOGO_CLIENTES_CONVENIO.VER_CATALOGO]),
    tab('Precio', `Precios`, `/Catalogo/Cliente/:id/Precios/:tabId?`, Precios, [ACCESS.CATALOGO_CLIENTES_PRECIO.VER_CATALOGO]),
    tab('Pago', `Pagos`, `/Catalogo/Cliente/:id/Pagos/:tabId?`, Pagos, [ACCESS.CATALOGO_CLIENTES_PAGO.VER_CATALOGO]),
    tab('Folio', `FoliosUso`, `/Catalogo/Cliente/:id/FoliosUso/:tabId?`, FoliosUso, [ACCESS.CATALOGO_CLIENTES_FOLIO.EDITAR_CATALOGO]),
    tab('Pago transportista', `PagoTransportista`, `/Catalogo/Cliente/:id/PagoTransportista/:tabId?`, PagosSucursales, [ACCESS.CATALOGO_CLIENTES_PAGO_TRANSPORTISTA.VER_CATALOGO]),
    tab('Factoraje', `Factoraje`, `/Catalogo/Cliente/:id/Factoraje/:tabId?`, Factoraje, [ACCESS.CATALOGO_CLIENTES_FACTORAJE.VER_CATALOGO]),
    tab('API', `Api`, `/Catalogo/Cliente/:id/API/:tabId?`, ApiConfig, [ACCESS.CATALOGO_CLIENTES_API.VER_CATALOGO]),
    tab('EDI', `Edi`, `/Catalogo/Cliente/:id/Edi/:tabId?`, EdiConfig, [ACCESS.CATALOGO_CLIENTES.VER_CATALOGO]),
  ]

  componentDidMount() {
    const { hasAccess } = this.context;
    const { history, match } = this.props;
    const validResources = this.tabs.filter((tab) => hasAccess(tab.access));
    let currentTab = history.location.pathname === `/Catalogo/Cliente/${match.params.id}` ? `/Catalogo/Cliente/${match.params.id}/${validResources[0].route}` : history.location.pathname
    this.setState({ recursos: validResources, currentTab });
  }

  componentDidUpdate(prevProps) {
    // if (this.props.location !== prevProps.location) {
    //   this.tabChange(this.props.match.params.tab)
    // }
  }

  tabChange = (newVal) => {
    // console.log(newVal)
    // this.props.history.push(`/Catalogo/Cliente/${this.props.match.params.id}/${newVal}`);
    this.setState({ currentTab: newVal });
    this.props.history.push(`${newVal}`);
  }

  render() {
    const { recursos, currentTab } = this.state;
    let baseUrl = `/Catalogo/Cliente/${this.props.match.params.id}`;
    return (
      <div>
        <div>
          <Cliente  />
          <AppBar position="static" color="default">
            <Tabs
              value={currentTab}
              onChange={(e, newValue) => { this.tabChange(newValue) }}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs"
            >
              {
                recursos.map(tab => (
                  <Tab key={tab.route} label={tab.label} value={`${baseUrl}/${tab.route}`} />
                ))
              }
            </Tabs>
          </AppBar>

          <Switch>
            {recursos.map(Tab => (
              <Route 
              key={Tab.route} 
              path={`${Tab.path}`}
              component={(props) => <Tab.Component {...props} back={false} reset={false} />} 
              />
            ))}
            {recursos[0] && <Route key={'index'} path={baseUrl} component={recursos[0].Component} />}
            {/* {this.tabs.map((tab) => (
              <Route key={tab.route} path={`${tab.path}`} component={(props) => <tab.component {...props} back={false} reset={false} />} />
            ))} */}
          </Switch>

          {/* <TabPanel value={value} index={`${baseUrl}/Generales`}>
            <p>djsakfd</p>
            <DatosGenerales />
          </TabPanel>
          <TabPanel value={value} index={`${baseUrl}/Remitentes`}>
            <Remitentes />
          </TabPanel>
          <TabPanel value={value} index={2}>
            Item Three
          </TabPanel>
          <TabPanel value={value} index={3}>
            Item Four
          </TabPanel>
          <TabPanel value={value} index={4}>
            Item Five
          </TabPanel>
          <TabPanel value={value} index={5}>
            Item Six
          </TabPanel>
          <TabPanel value={value} index={6}>
            Item Seven
          </TabPanel> */}
        </div>
      </div>
    )
  }
}

ClienteInfo.contextType = AuthContext;
export default withRouter(ClienteInfo)